module.exports = __webpack_public_path__ + "fonts/AvenirNextCondensed-BoldItalic.5a3db05e.woff";